import { ClipboardList } from "lucide-react";
import ComingSoon from "@/components/ComingSoon";

export default function Planning() {
  return (
    <ComingSoon
      icon={ClipboardList}
      title="Планирование"
      description="Выполнение работ по принятым предложениям"
      note="Здесь появится цепочка: предложение → позиции → этапы → трудозатраты → сотрудники → сроки → план/факт."
    />
  );
}
